<!-- Solo vive dentro de «Nueva solicitud»: el concentrador pone el
     encabezado y el avance, y dice cuál de las dos vistas se ve. -->
<div class="sia">

  <!-- ==================== El formulario ==================== -->
  <section class="sia-form table-page__card" *ngIf="pestana === 'solicitar'">

    <div class="sia-fila">
      <div class="sia-campo">
        <label class="sia-lbl sia-lbl--req" for="siaNombre">¿Qué IA necesitas?</label>
        <input id="siaNombre" type="text" class="sia-input" maxlength="120"
               placeholder="Ej. Gemini, Perplexity, Midjourney…"
               [(ngModel)]="nombreIa" name="nombreIa">
      </div>
      <div class="sia-campo">
        <label class="sia-lbl sia-lbl--req" for="siaUrl">Link de la IA</label>
        <input id="siaUrl" type="url" class="sia-input" maxlength="500"
               placeholder="https://…"
               [(ngModel)]="urlIa" name="urlIa">
      </div>
    </div>

    <!-- Los dos textos largos van a la par: son las dos preguntas que de
         verdad decide quien evalúa, y separarlas alarga la pantalla. -->
    <div class="sia-fila">
      <div class="sia-campo">
        <label class="sia-lbl sia-lbl--req" for="siaObjetivo">Propósito</label>
        <textarea id="siaObjetivo" class="sia-input sia-input--area" rows="3"
                  maxlength="2000" [(ngModel)]="proposito" name="proposito"
                  placeholder="Qué problema resuelve o qué quieres lograr."></textarea>
      </div>
      <div class="sia-campo">
        <label class="sia-lbl sia-lbl--req" for="siaUso">Uso previsto</label>
        <textarea id="siaUso" class="sia-input sia-input--area" rows="3"
                  maxlength="2000" [(ngModel)]="usoPrevisto" name="usoPrevisto"
                  placeholder="En qué trabajo, con qué frecuencia y quién la usaría."></textarea>
      </div>
    </div>

    <div class="sia-fila sia-fila--3">
      <div class="sia-campo">
        <label class="sia-lbl sia-lbl--req" for="siaArea">Área</label>
        <select id="siaArea" class="sia-input" [(ngModel)]="idArea" name="idArea">
          <option [ngValue]="null">— Escoge el área —</option>
          <option *ngFor="let a of areas" [ngValue]="a.id">{{ a.area }}</option>
        </select>
      </div>
      <!-- Proveedor: obligatorio desde el 29/09/2026, con su máximo a la
           vista junto a la etiqueta. -->
      <div class="sia-campo">
        <div class="sia-lbl-fila">
          <label class="sia-lbl sia-lbl--req" for="siaProv">Proveedor</label>
          <span class="sia-cuenta" [class.es-casi]="proveedor.length >= 135">{{ proveedor.length }}/150</span>
        </div>
        <input id="siaProv" type="text" class="sia-input" maxlength="150"
               placeholder="Ej. Google, OpenAI…"
               [(ngModel)]="proveedor" name="proveedor">
      </div>
      <!-- Teléfono: obligatorio (30/09/2026), solo números y 10 dígitos
           (29/09/2026). Lo que no es número no entra, se teclee o se pegue. -->
      <div class="sia-campo">
        <label class="sia-lbl sia-lbl--req" for="siaTel">Teléfono</label>
        <input id="siaTel" type="tel" class="sia-input" maxlength="10" inputmode="numeric"
               autocomplete="tel-national" placeholder="10 dígitos, por si te preguntan algo"
               [value]="telefonoContacto" (input)="soloDigitos($event)">
      </div>
    </div>

    <div class="sia-fila">
      <!-- Es la pregunta que dispara la evaluación de riesgo de la norma,
           y cuesta dos botones. -->
      <div class="sia-campo">
        <label class="sia-lbl">¿Va a tratar datos de la empresa o personales?</label>
        <div class="sia-ops">
          <button type="button" class="sia-op" *ngFor="let d of DATOS"
                  [class.es-activa]="datosSensibles === d.valor"
                  [attr.data-v]="d.valor"
                  (click)="datosSensibles = d.valor">
            {{ d.texto }}
          </button>
        </div>
      </div>
      <div class="sia-campo">
        <!-- Obligatoria desde el 29/09/2026, y no en el pasado. -->
        <label class="sia-lbl sia-lbl--req" for="siaFecha">¿Para cuándo la necesitas?</label>
        <input id="siaFecha" type="date" class="sia-input" [min]="hoy"
               [(ngModel)]="fechaRequerida" name="fechaRequerida">
      </div>
    </div>

    <!-- El DAR: se sube el Excel del FOR-012, o se llena aquí mismo. -->
    <div class="sia-campo sia-campo--archivos">
      <!-- Obligatorio desde el 29/09/2026: uno de los dos, subirlo o llenarlo. -->
      <label class="sia-lbl sia-lbl--req">Archivo DAR</label>
      <div class="sia-subir">
        <div class="sia-subir__ops">
          <label class="sia-archivo sia-archivo--subir">
            <span class="material-icons">upload_file</span>
            Subir el DAR
            <input type="file" multiple [attr.accept]="EXTENSIONES"
                   (change)="eligeArchivos($event)" hidden>
          </label>
          <span class="sia-o">o</span>
          <button type="button" class="sia-archivo sia-archivo--llenar" (click)="abreDar()">
            <span class="material-icons">edit_note</span>
            {{ tieneDar ? "Editar el DAR" : "Llenarlo aquí" }}
          </button>
        </div>
        <span class="sia-pista">
          <b>FOR-012 Reporte DAR.</b>
          Obligatorio: súbelo en Excel o llénalo aquí, en pantalla.
        </span>
      </div>

      <div class="sia-adjuntos" *ngIf="tieneDar">
        <span class="sia-adjunto sia-adjunto--dar">
          <span class="material-icons">fact_check</span>
          <span class="sia-adjunto__nom">DAR capturado en pantalla</span>
          <button type="button" class="sia-adjunto__x" (click)="quitaDar()"
                  matTooltip="Descartar el DAR capturado"
                  aria-label="Descartar el DAR capturado">
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </span>
      </div>

      <div class="sia-adjuntos" *ngIf="archivos.length">
        <span class="sia-adjunto" *ngFor="let f of archivos; let i = index">
          <span class="material-icons">description</span>
          <span class="sia-adjunto__nom">{{ f.name }}</span>
          <button type="button" class="sia-adjunto__x" (click)="quitaArchivo(i)"
                  matTooltip="Quitar"
                  [attr.aria-label]="'Quitar ' + (f.name || 'el archivo')">
            <span class="material-icons" aria-hidden="true">close</span>
          </button>
        </span>
      </div>
    </div>

    <!-- Lo que falta, en cuanto falta algo. Un boton apagado sin decir
         por que se lee como una pantalla rota. Los botones van arriba,
         en el encabezado (ver #acciones). -->
    <footer class="sia-acciones" *ngIf="falta || !enviando">
      <span class="sia-falta" *ngIf="falta">
        <span class="material-icons">info_outline</span>{{ falta }}
      </span>
      <span class="sia-falta sia-falta--ok" *ngIf="!falta">
        <span class="material-icons">check_circle</span>Listo para enviar
      </span>
    </footer>
  </section>

  <!-- ==================== Mis solicitudes de IA ==================== -->
  <section class="sia-lista" *ngIf="pestana === 'mias'">

    <!-- Lo que faltó guardar de la última solicitud. Vive sólo mientras
         no se salga de la pantalla: los archivos están en memoria y el
         navegador no los conserva. Por eso lo dice, y por eso se puede
         reintentar aquí mismo. -->
    <div class="sia-rescate sia-cristal" *ngIf="pendienteDe !== null">
      <span class="material-icons">warning_amber</span>
      <div class="sia-rescate__txt">
        <b>Faltó guardar algo de {{ folioPendiente || "tu última solicitud" }}</b>
        <p>La solicitud se creó, pero {{ queFalto() }}.</p>
        <p class="sia-rescate__nota">
          Si sales de esta pantalla ya no se podrá reintentar desde aquí.
        </p>
      </div>
      <div class="sia-rescate__btns">
        <button type="button" class="sia-btn sia-btn--primario"
                [disabled]="reintentando" (click)="reintentaPendiente()">
          <span class="material-icons" aria-hidden="true">refresh</span>
          {{ reintentando ? "Reintentando…" : "Reintentar" }}
        </button>
        <button type="button" class="sia-btn" [disabled]="reintentando"
                (click)="descartaPendiente()">
          Descartar
        </button>
      </div>
    </div>

    <!-- Falló la consulta. Antes salía el cartel de "no has pedido
         ninguna IA", que es exactamente lo contrario de lo que pasa. -->
    <div class="sia-vacio sia-cristal" *ngIf="!cargando && miasCarga === 'falla'">
      <span class="material-icons">cloud_off</span>
      <p>{{ miasError || "No se pudieron cargar tus solicitudes." }}</p>
      <p class="sia-vacio__nota">
        No quiere decir que no tengas ninguna: no se pudo preguntar.
      </p>
      <button type="button" class="sia-btn sia-btn--primario" (click)="cargar()">
        <span class="material-icons" aria-hidden="true">refresh</span> Reintentar
      </button>
    </div>

    <!-- Sin botón propio: «Solicitar IA» ya está en el encabezado del
         concentrador, justo arriba. -->
    <div class="sia-vacio sia-cristal"
         *ngIf="!cargando && miasCarga !== 'falla' && !mias.length">
      <span class="material-icons">smart_toy</span>
      <p>Todavía no has pedido ninguna IA.</p>
    </div>

    <!-- Cada tarjeta toma el color de SU estado: de un vistazo se ve
         cuáles esperan y cuáles ya se resolvieron. -->
    <article class="sia-tarjeta sia-cristal" [ngClass]="clase(s)"
             [class.es-destacada]="s.idSolicitudIa === resaltada"
             [attr.id]="'sia-sol-' + s.idSolicitudIa"
             *ngFor="let s of mias; trackBy: trackSolicitud">
      <div class="sia-tarjeta__cuerpo">
        <div class="sia-tarjeta__que">
          <span class="sia-folio">{{ s.folio }}</span>
          <b>{{ s.nombreIa }}</b>
        </div>

        <a class="sia-link" *ngIf="s.urlIa" [href]="s.urlIa" target="_blank"
           rel="noopener noreferrer">
          <span class="material-icons">open_in_new</span>{{ s.urlIa }}
        </a>

        <p class="sia-tarjeta__obs" *ngIf="s.proposito">{{ s.proposito }}</p>

        <div class="sia-tarjeta__pie">
          <span *ngIf="s.area">{{ s.area }}</span>
          <span *ngIf="s.fechaSolicitud"> · pedida el {{ fechaLegible(s.fechaSolicitud) }}</span>
          <span *ngIf="s.responsable"> · la ve {{ s.responsable }}</span>
          <span *ngIf="s.archivos"> · {{ s.archivos }} archivo(s)</span>
        </div>

        <!-- Lo que tiene que hacer, si algo — y con qué hacerlo. Antes
             decía "entra al detalle y responde" y ese detalle no existe
             para quien pide: la solicitud se quedaba parada. -->
        <div class="sia-pendiente" *ngIf="pendiente(s)">
          <span class="material-icons">priority_high</span>
          <span class="sia-pendiente__txt">{{ pendiente(s) }}</span>
          <button type="button" class="sia-btn sia-btn--primario sia-btn--chico"
                  *ngIf="s.estatus === 'INFORMACION_REQUERIDA'"
                  (click)="responde(s)">
            <span class="material-icons" aria-hidden="true">reply</span> Responder
          </button>
        </div>

        <!-- El resultado de la evaluación, cuando ya lo hay: qué se
             decidió, quién, cuándo y POR QUÉ, completo. Sustituye al
             renglón de antes, que sólo traía el motivo (recortado a la
             vista) y el nombre al final. -->
        <section class="sia-resultado" *ngIf="tieneDictamen(s)"
                 [class.es-no]="s.estatus === 'RECHAZADA'"
                 [attr.aria-labelledby]="'sia-res-' + s.idSolicitudIa">
          <header class="sia-resultado__cab">
            <span class="sia-resultado__ico material-icons" aria-hidden="true">
              {{ s.estatus === 'APROBADA' ? 'verified' : 'block' }}
            </span>
            <div class="sia-resultado__tit">
              <span class="sia-resultado__eti" [id]="'sia-res-' + s.idSolicitudIa">
                Resultado de la evaluación
              </span>
              <b class="sia-resultado__veredicto">
                {{ s.estatus === 'APROBADA' ? 'Autorizada' : 'No autorizada' }}
              </b>
            </div>
            <div class="sia-resultado__quien" *ngIf="s.dictaminador || s.fechaDictamen">
              <span *ngIf="s.dictaminador">
                <span class="material-icons" aria-hidden="true">how_to_reg</span>
                Dictaminó {{ s.dictaminador }}
              </span>
              <span *ngIf="s.fechaDictamen">
                <span class="material-icons" aria-hidden="true">event</span>
                {{ fechaLegible(s.fechaDictamen) }}
              </span>
            </div>
          </header>

          <div class="sia-resultado__cuerpo">
            <div class="sia-resultado__porque" *ngIf="s.dictamenMotivo">
              <span class="sia-resultado__sub">Por qué</span>
              <p>{{ s.dictamenMotivo }}</p>
            </div>

            <ng-container *ngTemplateOutlet="evidenciaEval; context: { $implicit: s }"></ng-container>

            <!-- Con dictamen y sin archivos, se dice. Sólo con la cuenta en
                 0: si no viene (servidor sin actualizar) no se sabe, y
                 decir "no hay" sería inventarlo. -->
            <p class="sia-evid__nada" *ngIf="s.evidenciasEval === 0">
              <span class="material-icons" aria-hidden="true">folder_off</span>
              No se adjuntó evidencia de la evaluación.
            </p>
          </div>
        </section>

        <!-- Sin dictamen todavía, la evidencia va suelta: quien evalúa la
             puede ir subiendo mientras revisa, y quien pidió ya la ve. -->
        <div class="sia-evid--suelta" *ngIf="!tieneDictamen(s) && (s.evidenciasEval || 0) > 0">
          <ng-container *ngTemplateOutlet="evidenciaEval; context: { $implicit: s }"></ng-container>
        </div>

        <div class="sia-inventario" *ngIf="s.inventarioFolio">
          <span class="material-icons" aria-hidden="true">inventory_2</span>
          <span>
            Ya está en el inventario de IA como <b>{{ s.inventarioFolio }}</b><ng-container
              *ngIf="s.matrizFolio"> y en la Matriz de Riesgos IA como
              <b>{{ s.matrizFolio }}</b></ng-container><ng-container
              *ngIf="!s.matrizFolio && s.matrizPropuesta === 'PENDIENTE'"> y propuesta a la
              Matriz de Riesgos IA, <b>pendiente de aprobar</b></ng-container><ng-container
              *ngIf="!s.matrizFolio && s.matrizPropuesta === 'DESCARTADO'">. Su propuesta a la
              Matriz de Riesgos IA se descartó</ng-container>
          </span>
        </div>
      </div>

      <div class="sia-tarjeta__acciones">
        <span class="sia-estatus">{{ etiqueta(s) }}</span>
        <button type="button" class="sia-ico sia-ico--no" (click)="retirar(s)"
                *ngIf="puedeRetirar(s)" matTooltip="Retirar la solicitud"
                [attr.aria-label]="'Retirar la solicitud ' + (s.folio || '')">
          <span class="material-icons" aria-hidden="true">undo</span>
        </button>
      </div>
    </article>

    <div class="sia-cargando" *ngIf="cargando">
      <span class="material-icons">hourglass_top</span> Consultando…
    </div>
  </section>
</div>

<!-- ==================== Los botones del formulario ====================
     Van arriba, en el encabezado de «Solicitudes», como en
     Capacitación (15/10/2026): el concentrador pinta esta plantilla ahí.
     «Cancelar» hace lo que hacía «Cambiar de tipo»: regresa a las tarjetas. -->
<ng-template #acciones>
  <button type="button" class="app-form-btn app-form-btn--secondary" (click)="descartar()">Limpiar</button>
  <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="enviando"
          (click)="volver.emit()">Cancelar</button>
  <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="enviando || !!falta"
          (click)="pedir()">{{ enviando ? "Enviando…" : "Enviar solicitud" }}</button>
</ng-template>

<!-- ==================== El DAR en pantalla ==================== -->
<app-modal-dar
  *ngIf="darAbierto"
  [dar]="darCapturado"
  [yo]="yo"
  (guardar)="guardaDar($event)"
  (cerrar)="cierraDar()"
></app-modal-dar>

<!-- ==================== La evidencia de la evaluación ====================
     Una sola plantilla para los dos sitios donde sale (dentro del
     resultado, o suelta mientras se evalúa): el mismo bloque escrito dos
     veces acabaría diciendo cosas distintas en cada uno.
     Sólo lectura: subir y quitar es del responsable, desde la gestión. -->
<ng-template #evidenciaEval let-s>
  <div class="sia-evid" *ngIf="(s.evidenciasEval || 0) > 0">
    <div class="sia-evid__cab">
      <span class="sia-evid__tit">
        <span class="material-icons" aria-hidden="true">attach_file</span>
        Evidencia de la evaluación
      </span>
      <button type="button" class="sia-evid__btn"
              [attr.aria-expanded]="evidAbierta(s)"
              [attr.aria-controls]="'sia-evid-' + s.idSolicitudIa"
              (click)="alternaEvidencia(s)">
        <span class="material-icons" aria-hidden="true">
          {{ evidAbierta(s) ? 'expand_less' : 'folder_open' }}
        </span>
        {{ evidAbierta(s) ? 'Ocultar evidencia' : 'Ver evidencia (' + s.evidenciasEval + ')' }}
      </button>
    </div>

    <!-- El panel es la región viva: al pasar de "consultando" a la lista
         o al fallo, el lector de pantalla lo anuncia. -->
    <div class="sia-evid__contenido" *ngIf="evidAbierta(s)"
         [id]="'sia-evid-' + s.idSolicitudIa" aria-live="polite">

      <p class="sia-evid__estado" *ngIf="evidCarga(s) === 'cargando'">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        Consultando la evidencia…
      </p>

      <!-- Falla de verdad (red, sesión, permiso), con su botón. Nunca se
           confunde con "no hay": la cuenta dice que sí hay. -->
      <div class="sia-evid__estado sia-evid__estado--falla" *ngIf="evidCarga(s) === 'falla'">
        <span class="material-icons" aria-hidden="true">{{ evidSesion(s) ? "lock_clock" : "cloud_off" }}</span>
        <!-- Con la sesión caída, reintentar nunca va a funcionar: se dice
             qué hacer en lugar de ofrecer un botón que no sirve. -->
        <span class="sia-evid__estado-txt">
          {{ evidSesion(s) ? "Tu sesión caducó. Vuelve a entrar para ver la evidencia." : "No se pudo abrir la lista de evidencia." }}
        </span>
        <button type="button" class="sia-evid__accion" *ngIf="!evidSesion(s)" (click)="cargaEvidencia(s)">
          <span class="material-icons" aria-hidden="true">refresh</span> Reintentar
        </button>
      </div>

      <!-- La cuenta decía que había, pero quien evalúa quitó los archivos
           entre la recarga y el clic. -->
      <p class="sia-evid__estado" *ngIf="evidCarga(s) === 'listo' && !evidLista(s).length">
        <span class="material-icons" aria-hidden="true">folder_off</span>
        Ya no hay evidencia adjunta.
      </p>

      <ul class="sia-evid__lista" *ngIf="evidCarga(s) === 'listo' && evidLista(s).length">
        <li class="sia-evid__item" *ngFor="let e of evidLista(s); trackBy: trackEvidencia"
            [attr.data-tipo]="tipoArchivo(e)">
          <span class="sia-evid__ico material-icons" aria-hidden="true">{{ iconoArchivo(e) }}</span>
          <div class="sia-evid__dato">
            <span class="sia-evid__nom" [title]="e.nombreArchivo || ''">
              {{ e.nombreArchivo || "Archivo sin nombre" }}
            </span>
            <span class="sia-evid__meta">
              {{ etiquetaTipo(e) }}<ng-container *ngIf="tamanoLegible(e.tamanioBytes)"> · {{ tamanoLegible(e.tamanioBytes) }}</ng-container><ng-container *ngIf="e.fechaCarga"> · {{ e.fechaCarga | fechaBitacora }}</ng-container>
            </span>
          </div>
          <div class="sia-evid__acc">
            <button type="button" class="sia-evid__accion" *ngIf="seVe(e)"
                    (click)="verEvidencia(e)"
                    [attr.aria-label]="'Ver ' + (e.nombreArchivo || 'el archivo') + ' en otra pestaña'">
              <span class="material-icons" aria-hidden="true">visibility</span> Ver
            </button>
            <button type="button" class="sia-evid__accion"
                    [disabled]="estaBajando(e)"
                    (click)="descargaEvidencia(e)"
                    [attr.aria-label]="'Descargar ' + (e.nombreArchivo || 'el archivo')">
              <span class="material-icons" aria-hidden="true">
                {{ estaBajando(e) ? 'hourglass_top' : 'download' }}
              </span>
              {{ estaBajando(e) ? "Bajando…" : "Descargar" }}
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
